import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledInput from 'components/atoms/Inputs/Input/Input.styles';
import {withMemo} from 'helpers/wrapper';

const Input = withMemo(React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'Input');

  return <StyledInput ref={ref} {...innerProps} />
}));

Input.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default Input;
